<template>
    <div class="ratingScale-container">
        <div v-if="isPreview" class="preview-tip">
            <span class="warning-img" />  <span style="padding-left: 0.25rem">{{$t("ratingScale.warningText2")}}</span>
        </div>
        <div class="submitted-tip" v-if="!isSubmitType">
            <span class="warning-img" />  <span style="padding-left: 0.25rem">{{$t("ratingScale.warningText1")}}</span>
        </div>

         <div class="header-top" v-if="$route.query.__inArticle__ != 1">
        </div>
        <p v-show="ratingObj.notice" v-if="$route.query.__inArticle__ != 1" class="header-notice" ref="notice">{{ ratingObj.notice }}</p>
        <template v-for="(item,index) in ratingScaleList">
            <div class="ratingScale-item " :class="{'requriredItem':item.isOptional == 0}"  :key="index" v-if="item.type != 102012">
                <div class="title flexC" v-if="item.examItemName">
                    <!-- {{$t("ratingScale.project")}} -->
                    <!-- <span >【</span> -->
                    <p class="txt">{{item.examItemName}}</p>
                    <!-- <span>】</span> -->
                </div>
                <div class="choice" v-if="item.type == 102011">
                    <div class="choice-container flexC">
                        <span class="label">{{$t("ratingScale.numericalValue")}}：</span>
                        <van-field v-model="item.inputAnswer" v-if="isSubmitType"  type="number" class="value" style="padding: 0;" placeholder="请输入"/>
                        <!-- <input type="number"  v-if="isSubmitType" class="value" onblur="this.value=this.value.replace(/(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,#}$)/,'')" placeholder="请输入"> -->
                        <p class="value" v-else>
                            <span class="txt">{{item.inputAnswer}}</span>
                            <!-- danger -->
                            <span class="normal" v-if="item.examItemIsDnaTest != 1" :class="Number(item.inputAnswer) > Number(item.examItemLow)&&Number(item.inputAnswer) < Number(item.examItemHigh)?'':'danger'">{{Number(item.inputAnswer) > Number(item.examItemLow)&&Number(item.inputAnswer) < Number(item.examItemHigh)?'正常':'异常'}}</span>
                        </p>
                        <span class="unit">{{item.examItemUnit}}</span>
                    </div>
                    <div class="choice-normaiRange flexC">
                        {{$t("ratingScale.normaiRange")}}：{{item.examItemLow}}~{{item.examItemHigh}}
                    </div>
                </div>
                 <div class="assay-time picture  flexC" v-if="item.type == 102005">
                    <span class="label">
                        {{$t("ratingScale.picture")}}：
                    </span>
                    <van-uploader class="uploadimgContainer " accept="image/*" v-if="isSubmitType||item.imgUrlsAnswer.length!=0" v-model="item.imgUrlsAnswer" :multiple="true" :max-count="100" :class="{'isedituoloader':!isSubmitType}">
                        <div class="uploadbox">
                            <img src="@/assets/img/upload-img-icon.png" alt="">
                            <p>上传图片</p>
                        </div>
                    </van-uploader>
                    <p v-else>暂无图片</p>
                </div>
                <div class="ratingScale-text choice" v-if="item.type == 102003 || item.type == 102005">
                    
                    <div class="choice-container flexC">
                        <span class="label">{{$t("ratingScale.content")}}：</span>
                        <input type="text" v-model="item.inputAnswer" v-if="isSubmitType" class="value" placeholder="请输入">
                        <p class="value" v-else>
                            {{item.inputAnswer}}
                        </p>
                    </div>
                </div>
                <div class="selectOption-container" v-if="item.type == 102002">
                    <div class="options-item " :class="{'itamActive':citem.isSelected == 1}" v-for="(citem,cindex) in item.questionOpts" :key="cindex" @click="selectOption(item,cindex)" >
                        <span class="txt">{{citem.label}}</span>
                    </div>
                </div>
            </div>
        </template>
        <div class="ratingScale-item">
            <div class="assay-time flexC" >
                <span class="label">
                    {{$t("ratingScale.assayTime")}}：
                </span>
                <input type="text" readonly :value="currentDate?getLocalDateTime(currentDate):''" class="input" placeholder="请选择" @click="isSubmitType?DateShow = true:''">
            </div>
            <div class="assay-time picture  flexC" >
                <span class="label">
                    {{$t("ratingScale.testSheet")}}：
                </span>
                <van-uploader class="uploadimgContainer " accept="image/*" v-if="isSubmitType||uploadimg.length!=0" v-model="uploadimg" :multiple="true" :max-count="10000" :class="{'isedituoloader':!isSubmitType}">
                    <div class="uploadbox">
                        <img src="@/assets/img/upload-img-icon.png" alt="">
                        <p>上传图片</p>
                    </div>
                </van-uploader>
                <p v-else>暂无化验单</p>
            </div>
        </div>
        <div class="ratingScale-btn" @click="submit" v-if="isSubmitType&&!isPreview">
            确认提交
        </div>
        <van-overlay v-show="DateShow" class-name="picketDate">
            <div class="null" @click="DateShow=false"></div>
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                :title='$t("personalDetail.selectDay")'
                :min-date="minDate"
                @confirm="dateConfirm"
                @cancel="DateShow=false"
                :max-date="maxDate"
            />
        </van-overlay>
        <dialog-login :overlay-show="loginOverlay" :filed="'loginOverlay'" ></dialog-login>
    </div>
</template>

<script>
import { getLocalDateTime } from "@/utils/date"
import dialogLogin from "@/components/dialoglogin/index";

export default {
    components:{
        dialogLogin,
    },
    data () {
        return {
            loginOverlay:false,
            DateShow:false,
            // 是否已提交
            isSubmitType:false,
            // 是否预览状态
            isPreview:false,
            ratingScaleList:[],
            ratingObj:{},
            uploadimg:[],
            currentDate:new Date(),
            getLocalDateTime,
            maxDate:new Date(),
            minDate:new Date(1970,0,1),
            questionaireId:null,
        }
    },
    created () {
        this.getRatingScaleData();
        // 返回 IM 使用
        // console.log(21313,sessionStorage.getItem("IMToQuestIons"));
        if(localStorage.getItem("IMToQuestIons") == 1){
            localStorage.setItem("IMToQuestIons",2)
        }
    },
    methods: {
        dateConfirm(e){
            console.log(e);
            this.DateShow = false;
        },
        async uploadFileImg(e){
            let r = this.$uploadAxios.post('upload/base64-upload', {data:e.content,fileName:e.file.name});
            return r;
        },
        async submit(data){
            for (let i = 0; i < this.ratingScaleList.length; i++) {
                const it = this.ratingScaleList[i];
                if(it.type == 102003){
                    if(!it.inputAnswer && it.isOptional == 0){
                        this.$toast(it.examItemName+"未填写")
                        return;
                    }
                }
                if(it.type == 102002){
                    let selectType = false;
                    for (let g = 0; g < it.questionOpts.length; g++) {
                        const gt = it.questionOpts[g];
                        if(gt.isSelected==1){
                            selectType = true;
                        }
                    }
                    if(!selectType && it.isOptional == 0){
                        this.$toast(it.examItemName+"未选择")
                        return;
                    }
                }
                if(it.type == 102005){
                    if(!it.imgUrlsAnswer||it.imgUrlsAnswer.length == 0 && !it.inputAnswer && it.isOptional == 0){
                        this.$toast(it.examItemName+this.$t("ratingScale.picture")+"未选择或内容未填写")
                        return
                    }
                }
                if(it.type == 102011){
                    if(!it.inputAnswer && it.isOptional == 0){
                        this.$toast(it.examItemName+"未填写")
                        return;
                    }
                }
            }
            if(!this.currentDate){
                this.$toast(it.examItemName+"未填写")
                return;
            }
            // console.log(this.uploadimg);
            const toast = this.$Toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				message: this.$t("message.loadingTxt")
			});	
            for (let i = 0; i < this.ratingScaleList.length; i++) {
                const it = this.ratingScaleList[i];
                if(it.type == 102005 && it.imgUrlsAnswer.length != 0){
                    let childImgUrlsAnswer = [];
                    for (let g = 0; g < it.imgUrlsAnswer.length; g++) {
                        const gt = it.imgUrlsAnswer[g];
                        await this.uploadFileImg(gt).then(res=>{
                            childImgUrlsAnswer.push(res.data);
                        });
                    }
                    it.imgUrlsAnswer = childImgUrlsAnswer;
                }                
            }
            let imgUrlsAnswer = [];
            for (let i = 0; i < this.uploadimg.length; i++) {
                const it = this.uploadimg[i];
                await this.uploadFileImg(it).then(res=>{
                    imgUrlsAnswer.push(res.data);
                });
            }
            let index = this.ratingScaleList.findIndex(item => item.type == 102012);
            if(index||index==0){
                this.ratingScaleList[index].imgUrlsAnswer = imgUrlsAnswer;
            }
            if(this.currentDate){
                this.ratingScaleList[index].inputAnswer = getLocalDateTime(this.currentDate);
            }
            
            let datadd = {
                questions:this.ratingScaleList,
                questionaireDefId:this.$route.query.questionaireDefId,
                questionaireId:this.questionaireId,
                id:this.questionaireId,
            }
            localStorage.setItem("ratingScaleForm",JSON.stringify(datadd))
            let resData = await this.$axios1.post('/questionaire2/submit',datadd)
            if(resData.errorCode == 0){
                localStorage.removeItem("ratingScaleForm")
                if(this.$route.query.__chat_id__){
                    const res = await this.$imapiAxio.post(
                        '/im/msg-send',
                        {
                        chatId: this.$route.query.__chat_id__,
                        sessionId: !this.$route.query.__session_id__?null:this.$route.query.__session_id__,
                        msgBody: {
                            type:"share",
                            content:{
                            desc:resData.data.title,
                            title:"量表已提交，请您查看！",
                            url:resData.data.url,
                            imgUrl: "http://img.11zhushou.com/cxo/png/hosp/iv_msg_qn.png"
                            }
                        },
                        msgSummary: '【量表】',
                        sessionEnv: {}
                        }
                    )
                }
                this.$router.replace('/ratingScale/after');
            }else {
                this.$toast(resData.errorMsg)
            }
            toast.clear();
            // imgUrlsAnswer
            // uploadimg
            
        },
        async getRatingScaleData(){
           
            let url = '/questionaire2/create-or-get';
            // if(this.$route.query['__hospPreview__']){
            //   url = '/questionaire/preview';
            // }
            // console.log(this.$route);
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            const res = await this.$axios1.post(url, {
                questionaireId: this.$route.query.questionaireId,
                questionaireDefId: this.$route.query.questionaireDefId||this.$route.query.previewQuestionaireId,
                msgPushId: this.$route.query._msg_push_id_,
                eventId: this.$route.query._event_id_        
            })
            toast.clear();
            if(res.errorCode == 0){
                for (let i = 0; i < res.data.questions.length; i++) {
                    const it = res.data.questions[i];
                    if(res.data.isSubmitted == 1&&it.imgUrlsAnswer&&it.imgUrlsAnswer.length!=0&&it.type == 102005){
                        let imgUrlsAnswerArr = []
                        for (let j = 0; j < it.imgUrlsAnswer.length; j++) {
                            const jt = it.imgUrlsAnswer[j];
                            imgUrlsAnswerArr.push({
                                url:jt
                            })                 
                        }
                        it.imgUrlsAnswer = imgUrlsAnswerArr;
                    }
                    if(!it.imgUrlsAnswer){
                        it.imgUrlsAnswer = [];
                    }
                }
                this.ratingScaleList = res.data.questions;
                this.ratingObj = res.data;
                this.questionaireId = res.data.id;
                if(!localStorage.getItem('ratingScaleForm')){
                }else{
                    let obj = JSON.parse(localStorage.getItem('ratingScaleForm'));
                    if(obj.questionaireDefId == this.$route.query.questionaireDefId){
                        this.ratingScaleList = obj.questions;
                        this.questionaireId = obj.questionaireId;
                    }
                }
                if(res.data.isSubmitted == 1){
                   
                    let r = res.data.questions.find(item => item.type == 102012);
                    if(r&&r.imgUrlsAnswer&&r.imgUrlsAnswer.length!=0){
                        this.uploadimg = [];
                        r.imgUrlsAnswer.forEach(it =>{
                            this.uploadimg.push({
                                url:it
                            });
                        })

                    }

                    imgUrlsAnswer
                }
                console.log(this.uploadimg);
                
                this.isSubmitType = res.data.isSubmitted == 0?true:false;
                this.isPreview = res.data.isPreview == 1 || this.$route.query.isPreview ? true:false;

                document.title = res.data.title;
            }

        },
        selectOption(item,index){
            if(!this.isSubmitType){
                return
            }
            // for (let i = 0; i < item.questionOpts.length; i++) {
            //     const it = item.questionOpts[i];
            //     if(i == index){
            //         it.isSelected = 1;
            //     }else{
            //         it.isSelected = 0;
            //     }
            // }
            item.questionOpts[index].isSelected = item.questionOpts[index].isSelected == 1?0:1;
            this.$forceUpdate();
        }
    }
}
</script>

<style lang="less" scoped>
.picketDate{
    display: flex;
    flex-direction: column;
    .null{
        flex: 1;
    }
    .van-picker {
        flex: auto 0 0;
    }
}
 .submitted-tip{
    background: #000000;
    opacity: 0.6;
    color:#fff;
    font-size:.6rem;
    padding-top:0.25rem;
    padding-bottom: 0.25rem;
    width:100%;
    max-width: 750px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    position: fixed;
    top:0.5rem;
    z-index: 100;
    left: 50%;
    transform: translate(-50%, 0);
    .warning-img{
      width: 1rem;
      height:1rem;
      background: url("../../assets/images/notice.png") no-repeat;
      background-size: 100% 100%;
    }
  }
.ratingScale-container{
    min-height: 100%;
    background: #F5F6FA;
    box-sizing: border-box;
    padding: 0.4rem 0.6rem;
    
    .header-top {
        position: relative;
        width: 100vw;
        max-width: 750px;
        margin-left: -0.6rem;
        height:10rem;
        background: url("~@/assets/images/sys/qusHeader.png") no-repeat;
        background-size: 100% 100%;
        padding-bottom:1rem;
        z-index: 1;
    }
    .header-notice {
        display: block;
        color: #FF671C;
        position: relative;
        width: 100%;
        padding: .5rem;
        box-sizing: border-box;
        border-radius: 0.32rem;
        background: #fff;
        font-size: .6rem;
        box-shadow: 0 0.08rem 0.16rem 0 #F0F0F1;
        margin-top:-1.5rem;
        // margin-bottom: 0.4rem;
        z-index: 9;
    }
    .preview-tip{
        background: #FF0000;
        opacity: 0.7;
        color:#fff;
        font-size:.6rem;
        padding-top:0.25rem;
        padding-bottom: 0.25rem;
        padding-left: 1rem;
        width:100%;
        max-width: 750px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        position: fixed;
        top:.5rem;
        left: 50%;
	    transform: translate(-50%,0);
        z-index: 100;
        .warning-img{
        width: 1rem;
        height:1rem;
        background: url("../../assets/images/warning.png") no-repeat;
        background-size: 100% 100%;
        }
    }
    .ratingScale-item{
        padding: 0 0.3rem;
        background: #FFFFFF;
        box-shadow: 0 0.08rem 0.16rem 0 #F0F0F1;
        border-radius: 0.32rem;
        margin-top: 0.4rem;
        .title{
            height: 2.4rem;
            padding: 0 0.3rem;
            width: 100%;
            align-items: center;
            font-size: 0.72rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            border-bottom: 0.02rem solid #EDEDED;
            color: #181818;
            position: relative;
           
        }
        .choice{
            overflow: auto;
            .choice-container{
                padding: 0.55rem 0.3rem;
                min-height: 0.9rem;
                line-height: 0.9rem;
                border-bottom: 0.02rem solid #EDEDED;
                font-size: 0.64rem;
                .label,.unit{
                    font-weight: 500;
                    color: #181818;
                }
                .value{
                    flex: 1;
                    font-weight: 400;
                    .normal{
                        font-size: 0.56rem;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #67C23A;
                        margin-left: 0.3rem;
                        padding-left: 0.8rem;
                        position: relative;

                        &::after{
                            position: absolute;
                            content: ' ';
                            width: 0.6rem;
                            height: 0.6rem;
                            left: 0;
                            top: 50%;
                            transform: translate(0,-50%);
                            background: url("~@/assets/img/ratingScale-value-status-icon1.png") no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                    .danger{
                        color: #F56C6C;
                        width: 0.6rem;
                        height: 0.54rem;
                        &::after{
                            background: url("~@/assets/img/ratingScale-value-status-icon2.png") no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                }
            }
            .choice-normaiRange{
                height: 1.24rem;
                background: #F2F6FC;
                font-size: 0.56rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #909399;
                border-radius: 0.16rem;
                margin: 0.48rem 0.3rem 0.6rem 0.3rem;
                padding: 0 0.24rem;

            }
        }
        .ratingScale-text{
            .choice-container{
                border: 0;
                align-items: flex-start;
            }
        }
        .selectOption-container{
            padding: 0.55rem 0.3rem;
            .options-item{
                padding-left: 0.8rem;
                font-size: 0.64rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #909399;
                position: relative;
                line-height: 0.9rem;
                margin-bottom: 0.1rem;
                &::after{
                    width: 0.6rem;
                    height: 0.6rem;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translate(0,-50%);
                    border: 0.04rem solid #909399;
                    border-radius: 50%;
                    content: ' ';
                }
            }
            .itamActive{
                &::after{
                    border: 0;
                    background: #3589FD;
                }
                &::before{
                    position: absolute;
                    border-radius: 50%;
                    content: ' ';
                    background: #fff;
                    left: 0.15rem;
                    top: 50%;
                    transform: translate(0,-50%);
                    width: 0.3rem;
                    height: 0.3rem;
                    z-index: 1;
                }
            }
        }
        .assay-time{
            font-size: 0.64rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #181818;
            flex: 0 0 auto;
            line-height: 0.9rem;
            padding: 0.55rem 0.3rem;
            border-bottom: 0.02rem solid #EDEDED;
            .input{
                flex: 1;
            }
        }
        
        .picture{
            align-items: flex-start;
            border: 0;
        }
    }
    .requriredItem{
        .title {
             &::after{
                position: absolute;
                content: '*';
                color: red;
                font-size: 0.6rem;
                left: -0.1rem;
                top: 50%;
                transform: translate(0,-50%);
            }
        }
    }
    .ratingScale-btn{
        height: 1.6rem;
        line-height: 1.6rem;
        text-align: center;
        font-size: 0.72rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        background: linear-gradient(180deg, #49C1FF 0%, #499FFF 100%);
        border-radius: 0.8rem;
        margin: 1.2rem 1rem 1.2rem 1rem;
    }
}
.uploadimgContainer{
    flex: 1;
    /deep/ .van-image {
        width:4rem;
        height: 4rem;    
    }
    /deep/ .van-uploader__preview-delete{
        font-size: 0.8rem;
        width: 0.6rem;
        height: 0.6rem;
        .van-icon {
            font-size: 0.64rem;
        }
    }
}
/deep/ .isedituoloader{
    .van-uploader__input-wrapper{
        display: none;
    }
    .van-uploader__preview-delete{
        display: none;
    }
}
.uploadbox{
    width:4rem;
    height: 4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #EDEEF2;
    border-radius: 8px;
    img{
        width: 1.6rem;
        height: 1.32rem;
    }
    p{
        font-size: 0.52rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #909399;
        margin-top: 0.2rem;
    }
}
</style>